import React, { Component } from "react";
import {
  Container,
  Grid,
  Image,
  Header,
  Button,
  Icon,
  Embed,
  Statistic
} from "semantic-ui-react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

import {
  FIND_CLUB_ROUTE,
  LOGIN_ROUTE,
  FACKBOOK_LINK,
  TWITTER_LINK,
  INSTAGRAM_LINK,
  BASE_URL
} from "../../constants/route.constants";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/FooterView";
import { APP_NAME } from "../../constants/resource.constants";
import "./home.css";

export default class Home extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>Home | {APP_NAME}</title>
          <meta
            name="description"
            content="Find any international GAA club around world. GAA International provides information on all gaelic games clubs including football, hurling and camoige."
          />
          <link
            rel="canonical"
            href={`${BASE_URL}${window.location.pathname}`}
          />
          <meta property="og:title" content={`Home | ${APP_NAME}`} />
          <meta
            property="og:description"
            content="Find any international GAA club around world. GAA International provides information on all gaelic games clubs including football, hurling and camoige."
          />
          <meta
            property="og:image"
            content="https://d3hfkx84ni8spj.cloudfront.net/misc/gaa-intl-lrg.png"
          />
          <meta
            property="og:url"
            content={`${BASE_URL}${window.location.pathname}/`}
          />
          <meta property="og:type" content="website" />
        </Helmet>
        <header>
          <NavBar {...this.props} />
        </header>
        <div>
          <div className="banner">
            <Container>
              <div className="banner-box">
                <h1 className="hero-title">
                  Find your local{" "}
                  <span className="highlight">International</span> club
                </h1>
                <p className="hero-text">
                  Get started now by finding your local club, or{" "}
                  <Link to={LOGIN_ROUTE}>Sign In</Link> to see where your
                  friends are playing and join them!
                </p>
                <Link to={FIND_CLUB_ROUTE}>
                  <Button size="huge" negative className="home__hero-btn">
                    Find Your Club Now
                  </Button>
                </Link>
              </div>
            </Container>
          </div>
          <div className="home__banner-stats">
            <Container>
              <Statistic.Group widths="three" inverted>
                <Statistic>
                  <Statistic.Value>437</Statistic.Value>
                  <Statistic.Label>Clubs</Statistic.Label>
                </Statistic>
                <Statistic color="green">
                  <Statistic.Value>50</Statistic.Value>
                  <Statistic.Label>Countries</Statistic.Label>
                </Statistic>
                <Statistic>
                  <Statistic.Value>826</Statistic.Value>
                  <Statistic.Label>Teams</Statistic.Label>
                </Statistic>
              </Statistic.Group>
            </Container>
          </div>
          <Container>
            <div className="spacer" />
            <Container textAlign="center">
              <Header as="h2" size="huge" className="home_header">
                Looking to transfer clubs?
              </Header>
              <Header size="large">
                {`It couldn't be easier.`}
                <br />
                {`Check out the video below to get started.`}
              </Header>
            </Container>
            <div className="spacer" />
            <Embed
              id="CGlJGvEulB8"
              source="youtube"
              placeholder="https://d3hfkx84ni8spj.cloudfront.net/misc/transfervideoplaceholder.jpg"
            />
            <div className="spacer" />
            <Grid columns={2} stackable={true}>
              <Grid.Column>
                <Image src="/img/map.jpg" />
              </Grid.Column>
              <Grid.Column verticalAlign="middle" className="home__join-block">
                <Header size="huge">
                  {`Join 1000's of people playing Gaelic Games around the world`}
                </Header>
                <Link to={FIND_CLUB_ROUTE}>
                  <Button size="huge" negative>
                    Find Your Club Now
                  </Button>
                </Link>
              </Grid.Column>
            </Grid>
            <div className="spacer" />
            <Grid
              columns={2}
              stackable={true}
              textAlign="center"
              verticalAlign="top"
            >
              <Grid.Column>
                <Header size="huge" className="home_header">
                  Support
                </Header>
                <p className="home_text">
                  Got a question about GAA International?
                </p>
                <p className="home_text">
                  <a href="mailto:info@gaa.international?subject=Support">
                    Email us
                  </a>{" "}
                  and we{"'"}ll be happy to help!
                </p>
              </Grid.Column>
              <Grid.Column className="home__follow-block">
                <Header size="huge" className="home_header">
                  Follow
                </Header>
                <p className="home_text">
                  The latest & greatest from GAA International
                </p>
                <div>
                  <a
                    target="_blank"
                    href={FACKBOOK_LINK}
                    rel="noopener noreferrer"
                    className="home__social-link"
                  >
                    <Icon name="facebook square" size="big" />
                  </a>
                  <a
                    target="_blank"
                    href={TWITTER_LINK}
                    rel="noopener noreferrer"
                    className="home__social-link"
                  >
                    <Icon name="twitter square" size="big" />
                  </a>
                  <a
                    target="_blank"
                    href={INSTAGRAM_LINK}
                    rel="noopener noreferrer"
                    className="home__social-link"
                  >
                    <Icon name="instagram" size="big" />
                  </a>
                </div>
              </Grid.Column>
            </Grid>
          </Container>
        </div>
        <Footer />
      </div>
    );
  }
}

Home.defaultProps = {
  requestClubs: () => ({}),
  clubs: []
};

Home.propTypes = {
  requestClubs: PropTypes.func,
  clubs: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  )
};



// WEBPACK FOOTER //
// ./src/routes/Home/View.js